export default __webpack_public_path__ + "static/media/lablogo.ce2898e2.svg";